"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiGatewayHeaders = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const fetchUtils_1 = require("../../client/fetchUtils");
const requestId_1 = require("../../client/requestId");
const getApiGatewayHeaders = (stage, clientId) => {
    const headers = {
        'x-atoz-client-id': clientId,
        'x-atoz-client-request-id': requestId_1.ATOZ_ClIENT_REQUEST_ID
    };
    if (stage !== fetchUtils_1.Stage.PROD) {
        headers['Authorization'] = `Bearer ${js_cookie_1.default.get('atoz-oauth-token')}`;
    }
    return Promise.resolve(headers);
};
exports.getApiGatewayHeaders = getApiGatewayHeaders;
